
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button } from '../components/ui/button';
import config from '../config';
import Link from '../components/Link';
import { setOrganizationId } from '../utils/fetch';
import SignInUpLayout from '../components/SignInUpLayout';
import { StoreContext } from '../store';
import { SubmitButton } from '@microrealestate/commonui/components';
import { TextField } from '../components/formfields/TextField';
import { toast } from 'sonner';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
const defaultValues = {
    email: '',
    password: ''
};
// Credenziali dell'account dimostrativo pubblico (fork Dimora)
const DEMO_CREDENTIALS = {
    email: 'giuseppe.dellipaoli@dimora.test',
    password: 'Dimora2026!'
};
const validationSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string().required()
});
export default function SignIn() {
    const { t } = useTranslation('common');
    const store = useContext(StoreContext);
    const [initialValues, setInitialValues] = useState(defaultValues);
    const [demoSubmitting, setDemoSubmitting] = useState(false);
    const [showCredentials, setShowCredentials] = useState(false);
    const router = useRouter();
    useEffect(() => {
        if (config.DEMO_MODE) {
            setInitialValues({
                email: 'demo@demo.com',
                password: 'demo'
            });
        }
    }, []);
    const signIn = useCallback(async ({ email, password }) => {
        try {
            const status = await store.user.signIn(email, password);
            if (status !== 200) {
                switch (status) {
                    case 422:
                        toast.error(t('Some fields are missing'));
                        return;
                    case 401:
                        toast.error(t('Incorrect email or password'));
                        return;
                    default:
                        toast.error(t('Something went wrong'));
                        return;
                }
            }
            await store.organization.fetch();
            if (store.organization.items.length) {
                if (!store.organization.selected) {
                    store.organization.setSelected(store.organization.items[0], store.user);
                }
                setOrganizationId(store.organization.selected._id);
                router.push(`/${store.organization.selected.name}/dashboard`, undefined, {
                    locale: store.organization.selected.locale
                });
            }
            else {
                router.push('/firstaccess');
            }
        }
        catch (error) {
            console.error(error);
            toast.error(t('Something went wrong'));
        }
    }, [router, store, t]);
    // Riempie i campi con le credenziali demo e invia subito il modulo.
    const signInWithDemo = useCallback(async (setValues) => {
        setValues({ ...DEMO_CREDENTIALS });
        setDemoSubmitting(true);
        // Il dialogo di benvenuto compare a ogni ingresso via "Prova la demo":
        // il flag vive in sessionStorage e viene consumato dal cruscotto.
        try {
            sessionStorage.setItem('dimora.benvenuto-demo', '1');
        }
        catch (e) {
            /* senza storage il dialogo semplicemente non compare */
        }
        try {
            await signIn(DEMO_CREDENTIALS);
        }
        finally {
            setDemoSubmitting(false);
        }
    }, [signIn]);
    if (store.organization.selected?.name) {
        router.push(`/${store.organization.selected.name}/dashboard`);
        return null;
    }
    return (<SignInUpLayout>
      <Formik enableReinitialize={true} initialValues={initialValues} validationSchema={validationSchema} onSubmit={signIn}>
        {({ isSubmitting, setValues }) => {
            return (<div className="p-5 md:p-0 md:max-w-md w-full">
              <Form className="space-y-8">
                {/* Ingresso principale: la demo. È il solo percorso che conta. */}
                <div className="space-y-4">
                  <div className="text-3xl md:text-4xl font-semibold text-secondary-foreground text-center md:text-left">
                    Entra nella demo
                  </div>
                  <p className="text-base text-muted-foreground text-center md:text-left">
                    Un gestionale di locazioni già popolato: immobili, inquilini,
                    contratti, affitti e ricevute. Nessuna registrazione.
                  </p>
                  <Button type="button" data-cy="demoSignin" data-tour="prova-demo" className="w-full h-16 text-xl font-semibold shadow-lg" disabled={isSubmitting || demoSubmitting} onClick={() => signInWithDemo(setValues)}>
                    {demoSubmitting ? 'Accesso in corso…' : 'Prova la demo'}
                  </Button>
                  <p className="text-xs text-center text-muted-foreground">
                    Dati di esempio, modificabili liberamente.
                  </p>
                </div>

                {/* Accesso con credenziali: percorso marginale, nascosto di default. */}
                <div className="pt-2 border-t border-border">
                  {!showCredentials ? (<button type="button" data-cy="showCredentials" className="w-full text-xs text-muted-foreground hover:text-foreground underline underline-offset-4 pt-4" onClick={() => setShowCredentials(true)}>
                      Hai già un account? Accedi con le tue credenziali
                    </button>) : (<div className="space-y-6 pt-4">
                      <TextField label={t('Email Address')} name="email"/>
                      <TextField label={t('Password')} name="password" type="password" autoComplete="current-password"/>
                      <SubmitButton fullWidth variant="outlined" label={!isSubmitting ? t('Sign in') : t('Signing in')}/>
                    </div>)}
                </div>
              </Form>
            </div>);
        }}
      </Formik>
      {!config.DEMO_MODE && (<div className="mt-10 lg:mt-0 lg:absolute lg:bottom-10 text-center text-muted-foreground w-full">
          {config.SIGNUP ? (<>
              {t('New to {{APP_NAME}}?', {
                    APP_NAME: config.APP_NAME
                })}{' '}
              <Link href="/signup" data-cy="signup">
                {t('Create an account')}
              </Link>
              .
            </>) : (<span data-cy="signupClosed">
              Vuoi un account?{' '}
              <Link href="/contatti" data-cy="linkContatti">
                Scrivici
              </Link>
              .
            </span>)}
        </div>)}
    </SignInUpLayout>);
}

    async function __Next_Translate__getStaticProps__19fd5e3c6a3__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/signin',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19fd5e3c6a3__ as getStaticProps }
  